// @react
import React, { ReactElement } from 'react'
// @common
import config from 'constants/config'
// @components
import Grid from '@bit/atd.web.grid'
import Spacer from '@bit/atd.web.spacer'
import { useMediaQuery } from '@material-ui/core'
import theme from '@bit/atd.web.theme'

/**
 * 5.0.0.1 Profile - Navigation
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=2258%3A4687
 *
 */

type PropsType = {
  children: ReactElement
}
const PaginationWrapper = (props: PropsType): ReactElement | null => {
  /**********************
   * PROPS
   **********************/
  const { children } = props

  /**********************
   * HOOKS
   **********************/
  const isMobile = useMediaQuery(
    theme.breakpoints.down('sm'),
    config.mediaQuery,
  )
  const pageFlexDirection = isMobile ? 'center' : 'flex-end'

  /**********************
   * RENDER
   **********************/
  if (props.children.props.count < 2) return null
  return (
    <Grid container direction="row" justify={pageFlexDirection}>
      <Grid item>
        <Spacer size={20} />
        {children}
      </Grid>
    </Grid>
  )
}

export default PaginationWrapper
